{
  "tid-document-capture-pres.instruction": "Varmista, että koko sivu on kehyksen sisällä ja että alaosan merkkialue on näkyvissä.",
  "tid-document-capture-pres.hint": "Skannaus tapahtuu automaattisesti",
  "tid-document-capture-pres.back": "Takaisin",
  "tid-document-capture-pres.help": "Ohje",
  "tid-document-capture-pres.message.glare": "Siirry pois suorasta valosta heijastusten välttämiseksi.",
  "tid-shared-tips-pres.title.mobile.scan.passport": "Vinkkejä skannaukseen",
  "tid-shared-tips-pres.continue.scan": "Yritä uudelleen",
  "tid-shared-tips-pres.cancel.passport": "Peruuta",
  "tid-shared-summary-pres.passengerLabel": "Matkustaja: ",
  "tid-shared-summary-pres.nationalityLabel": "Kansalaisuus: ",
  "tid-shared-tips-pres.imageWholePage": "Sisällytä koko sivu.",
  "tid-shared-tips-pres.imageBlur": "Varmista, että kuva on tarkka eikä siinä ole varjoja.",
  "tid-shared-tips-pres.imageReflection": "Varmista, että sivulla ei ole häikäisyä tai heijastuksia.",
  "tid-identity-instruction-pres.altMrz": "Passin tietosivu, jossa merkkirivi (koneellisesti luettava alue eli MRZ) on korostettu",
  "tid-collection-method-pres.methods": "Vahvista passisi",
  "tid-collection-method-pres.back": "Takaisin",
  "tid-collection-method-pres.scanTitle": "Skannaa kameralla",
  "tid-collection-method-pres.uploadTitle": "Lataa kuva",
  "tid-header.flight": "Lento",
  "tid-header.passengerName": "Matkustaja",
  "tid-document-capture-pres.message.dark": "Siirry lähemmäksi valonlähdettä, kuva on liian tumma.",
  "tid-gif-spinner.title.upload": "Ladataan",
  "tid-gif-spinner.description.upload": "Tämä kestää enintään 10 sekuntia.",
  "global.date-format.fullDateNumeric": "dd/MM/yyyy",
  "tid-gif-spinner.title.verify": "Vahvistetaan",
  "tid-gif-spinner.description.verify.passport": "Varmistamme passisi tiedot.<br/>Tämä kestää enintään 10 sekuntia."
}
